import { parse } from 'date-fns'
import differenceInYears from 'date-fns/difference_in_years'
import differenceInMonths from 'date-fns/difference_in_months'

export function  getAge(birthday) {
    let months = differenceInMonths(parse(Date.now()), new Date(birthday * 1000))
    let years = differenceInYears(Date.now(), new Date(birthday * 1000))

    let age = ''
    if (years > 0) {
        age += years + ' years '
    }
    if (months - years * 12 > 0) {
        age += months - years * 12 + ' months'
    }
    if (months === 0) {
        age += 'less than 1 months'
    }
    return age
}